import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
//import CustomChart from '../Charts/CustomChart.jsx';

class SettingsDialogPC extends React.Component {
  constructor(props) {
    super();
    this.state = {
      settings: props.settings,
    };
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}
         style={{ 'max-width': '800px', margin: 'auto' }}
      >
        <ModalHeader>Settings</ModalHeader>
        <ModalBody>
        </ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={() => {this.props.onApply(this.state.settings)}}>Apply</Button>
          <Button color='secondary' onClick={this.props.toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default SettingsDialogPC;
